import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a35d25e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-full",
  style: {"overflow":"hidden"}
}
const _hoisted_2 = { class: "w-full min-h-screen" }
const _hoisted_3 = {
  class: "lg:w-3/4 mx-auto px-4 lg:px-0 mt-32",
  style: {"width":"96% !important"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-3xl text-gray-900" }, "Recent Orders", -1))
const _hoisted_5 = { class: "flex flex-wrap" }
const _hoisted_6 = { class: "flex flex-wrap changesbutton" }
const _hoisted_7 = {
  key: 0,
  class: "mr-2 mat"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "mb-1 border-gray-300 rounded text-right ml-auto changesbutton" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  class: "test w-full mt-10 overflow-x-scroll table-auto",
  style: {"display":"block","overflow-x":"auto","white-space":"nowrap"}
}
const _hoisted_14 = {
  class: "font-light border-spacing-4 font-gray-800 text-sm",
  style: {"display":"table","width":"100%"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "bg-mute text-sm text-gray-800 h-10 text-left" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "pl-3 w-20" }, "Order No."),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "Ticket Buyer"),
  /*#__PURE__*/_createElementVNode("th", null, "Qty"),
  /*#__PURE__*/_createElementVNode("th", null, "Price"),
  /*#__PURE__*/_createElementVNode("th", null, "Date"),
  /*#__PURE__*/_createElementVNode("th", null, "Payment"),
  /*#__PURE__*/_createElementVNode("th", null, "Scanned At"),
  /*#__PURE__*/_createElementVNode("th", null, "Scanned By"),
  /*#__PURE__*/_createElementVNode("th", null, "Options")
], -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "pl-3 py-3" }
const _hoisted_18 = { class: "cursor-pointer space-x-4 font-normal text-green-500 items-center py-4" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick", "disabled"]
const _hoisted_23 = ["onClick", "disabled"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "9",
  class: "centerData space-x-4 py-4"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "No records present")
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  class: "w-full",
  style: {"display":"table"}
}
const _hoisted_28 = {
  key: 0,
  class: "min-h-screen h-full overflow-y-scroll fixed top-0 w-full px-4 md:pt-32 sm:pt-24 pt-16",
  style: {"background-color":"#0000005c"}
}
const _hoisted_29 = { class: "lg:w-2/5 md:w-1/2 relative sm:w-2/3 w-full mx-auto mb-10 bg-white rounded-xl py-6 px-4 sm:px-10" }
const _hoisted_30 = { class: "text-green-500 text-xl" }
const _hoisted_31 = { class: "absolute right-10 top-6" }
const _hoisted_32 = { class: "text-sm font-light text-gray-800" }
const _hoisted_33 = { class: "text-sm font-light text-gray-800" }
const _hoisted_34 = { class: "grid md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-6 mt-8" }
const _hoisted_35 = { class: "flex flex-col space-y-1" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "TICKET NAME", -1))
const _hoisted_37 = { class: "text-sm font-light text-gray-800" }
const _hoisted_38 = { class: "flex flex-col space-y-1" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "TICKET TYPE", -1))
const _hoisted_40 = { class: "text-sm font-light text-gray-800" }
const _hoisted_41 = { class: "flex flex-col space-y-1" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "QUANTITY", -1))
const _hoisted_43 = { class: "text-sm font-light text-gray-800" }
const _hoisted_44 = { class: "flex flex-col space-y-1" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "ORDER NO.", -1))
const _hoisted_46 = { class: "text-sm font-light text-gray-800" }
const _hoisted_47 = { class: "flex flex-col space-y-1" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "PAYMENT TYPE", -1))
const _hoisted_49 = { class: "text-sm font-light text-gray-800" }
const _hoisted_50 = { class: "flex flex-col space-y-1" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "PAYMENT STATUS", -1))
const _hoisted_52 = { class: "text-sm font-light text-gray-800" }
const _hoisted_53 = { class: "flex flex-col col-span-2 space-y-1" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs uppercase text-gray-800" }, "PURCHASE DATE", -1))
const _hoisted_55 = { class: "text-sm font-light text-gray-800" }
const _hoisted_56 = { class: "w-max mt-5 mb-3 mx-auto" }
const _hoisted_57 = {
  key: 1,
  class: "min-h-screen h-full overflow-y-scroll fixed top-0 w-full px-4 md:pt-32 sm:pt-24 pt-16",
  style: {"background-color":"#0000005c"}
}
const _hoisted_58 = { class: "lg:w-2/5 md:w-1/2 relative sm:w-2/3 w-full mx-auto mb-10 bg-white rounded-xl py-6 px-4 sm:px-10" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-green-500 text-xl text-center" }, "Reissue Ticket Order", -1))
const _hoisted_60 = { class: "absolute right-10 top-6" }
const _hoisted_61 = { class: "container" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_64 = { class: "row col-md-12" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Full Name", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_68 = { class: "row col-md-12" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email Address", -1))
const _hoisted_70 = { class: "w-max mt-5 mb-3 mx-auto" }

export function render(_ctx, _cache) {
  const _component_vue_element_loading = _resolveComponent("vue-element-loading")
  const _component_HeaderDashboard = _resolveComponent("HeaderDashboard")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_FooterDashboard = _resolveComponent("FooterDashboard")
  const _component_QRScanner = _resolveComponent("QRScanner")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_vue_element_loading, {
      active: _ctx.isloading,
      text: "MYLE",
      "text-style": _ctx.loadStyle,
      "is-full-screen": true,
      class: "h-full background-overlay",
      spinner: "bar-fade-scale",
      color: "#ffffff"
    }, null, 8, ["active", "text-style"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderDashboard),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.selectedEvent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "ddown",
                      placeholder: "Select Ticket",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.defName) = $event)),
                      class: "w-full border h-10 mt-2 border-gray-300 rounded wful1",
                      style: {"outline":"none !important","border-width":"1px !important","border-right":"1px solid #00000029 !important"},
                      readonly: ""
                    }, null, 512), [
                      [_vModelText, _ctx.defName]
                    ]),
                    (!_ctx.isloading)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._ctx.selectedEvent.donationTickets ,..._ctx.selectedEvent.freePaidTickets], (rec) => {
                            return (_openBlock(), _createElementBlock("li", {
                              onClick: $event => {_ctx.defselected = rec.ticketCode; _ctx.dropTicket({ target: {value: rec.ticketCode} }); _ctx.defName = rec.ticketName;},
                              key: rec.ticketCode
                            }, _toDisplayString(rec.ticketName), 9, _hoisted_9))
                          }), 128)),
                          _createElementVNode("li", null, [
                            _createElementVNode("p", {
                              onClick: _cache[1] || (_cache[1] = $event => {_ctx.defselected = -2; _ctx.dropTicket({ target: {value: -2} }); _ctx.defName='All Ticket(s) Orders'}),
                              class: "text-green-500"
                            }, " All Ticket(s) Orders ")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "sbn",
                  placeholder: "Search By Name",
                  onKeyup: _cache[2] || (_cache[2] = _withKeys((...args) => (_ctx.makesearch && _ctx.makesearch(...args)), ["enter"])),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.searchtext) = $event)),
                  class: "w-full border h-10 mt-2 border-gray-300 rounded rounded-tr-none rounded-br-none wful",
                  style: {"outline":"0px !important","-webkit-appearance":"none","min-width":"200px !important"}
                }, null, 544), [
                  [_vModelText, _ctx.searchtext]
                ]),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.cleartext && _ctx.cleartext(...args))),
                  id: "sbnb",
                  class: "mt-2 px-5 py-2 text-sm text-white border text-green-500 hover:text-green-600 transition duration-300 ease-in-out border-gray-300",
                  style: {"height":"2.5rem","border-left-width":"0 !important"}
                }, " X ")
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = $event => (_ctx.showQRModalPopup())),
                class: _normalizeClass([{'opa-50': !_ctx.enableButton}, "close mt-3 px-2 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out"])
              }, " Scan Tickets ", 2),
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = $event => (_ctx.scanData('ATTENDEES'))),
                class: "close mt-2 ml-2 px-2 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out"
              }, " Export Attendees Details "),
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = $event => (_ctx.scanData('FINANCIAL'))),
                disabled: _ctx.getDetails == 'VIEWER'  || _ctx.getDetails == 'EDITOR',
                class: "close mt-2 ml-2 px-2 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
              }, " Export Financial Details ", 8, _hoisted_12)
            ])
          ]),
          _createElementVNode("table", _hoisted_13, [
            _createElementVNode("tbody", _hoisted_14, [
              _hoisted_15,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (rec) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "border-b hover:bg-gray-100",
                  onClick: $event => (_ctx.open(rec))
                }, [
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("p", null, _toDisplayString(rec.orderCode), 1)
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    _createTextVNode(_toDisplayString(rec.user.fullName) + " ", 1),
                    _hoisted_19,
                    _createTextVNode(_toDisplayString(rec.user.email), 1),
                    _hoisted_20,
                    _createTextVNode(_toDisplayString(rec.user.phoneNumber), 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(rec.totalPurchasedTickets), 1),
                  _createElementVNode("td", null, _toDisplayString('$' + rec.totalPaid.toFixed(2)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.getDate(rec.purchasedDateTime)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.removeunderscore(rec.paymentStatus)), 1),
                  _createElementVNode("td", null, _toDisplayString(rec.scannedTickets?.createdAt
                  ? _ctx.formatDateTime(rec.scannedTickets.createdAt)
                  : '—'), 1),
                  _createElementVNode("td", null, _toDisplayString(rec.scannedTickets?.scannerUser?.fullName
                  ? rec.scannedTickets.scannerUser.fullName
                  : '—'), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      onClick: $event => (_ctx.checkin($event, rec)),
                      class: _normalizeClass([{'opa-50': rec.totalScanned >= rec.totalPurchasedTickets || _ctx.isloading }, "mt-2 px-5 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out"])
                    }, " Check-In ", 10, _hoisted_21),
                    _createElementVNode("button", {
                      onClick: $event => (_ctx.resend($event, rec)),
                      disabled: _ctx.getDetails == 'VIEWER'  || _ctx.getDetails == 'EDITOR',
                      class: _normalizeClass([{'opa-50': rec.totalScanned == rec.totalPurchasedTickets || _ctx.isloading }, "mt-2 ml-2 px-5 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"])
                    }, " Resend ", 10, _hoisted_22),
                    _createElementVNode("button", {
                      onClick: $event => (_ctx.reissue($event, rec)),
                      disabled: _ctx.getDetails == 'VIEWER'  || _ctx.getDetails == 'EDITOR',
                      class: _normalizeClass([{'opa-50': rec.totalScanned == rec.totalPurchasedTickets || _ctx.isloading }, "mt-2 ml-2 px-5 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"])
                    }, " Reassign ", 10, _hoisted_23)
                  ])
                ], 8, _hoisted_16))
              }), 256)),
              (_ctx.list.length <= 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_24, _hoisted_26))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_Paginator, {
              totalPages: _ctx.totalPages,
              onNextPage: _ctx.nextPage
            }, null, 8, ["totalPages", "onNextPage"])
          ])
        ])
      ]),
      _createVNode(_component_FooterDashboard),
      (_ctx.showModel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.tickRecord.user.fullName), 1),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("p", {
                  class: "close text-xl opacity-70 font-black text-green-500 cursor-pointer",
                  onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.close && _ctx.close(...args)))
                }, " ╳ ")
              ]),
              _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.tickRecord.user.email), 1),
              _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.tickRecord.user.phoneNumber), 1),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.tickRecord.ticket.ticketName), 1)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.tickRecord.ticket.ticketType), 1)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.tickRecord.totalPurchasedTickets), 1)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.tickRecord.orderCode), 1)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.tickRecord.paymentType), 1)
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.tickRecord.paymentStatus.replace('_', ' ')), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.formatDateTime(_ctx.tickRecord.purchasedDateTime) + (_ctx.tickRecord.noEndDate ? ('-'
            + _ctx.getTime(_ctx.tickRecord.purchasedDateTime)) : '')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.close && _ctx.close(...args))),
                  class: "close px-8 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out mt-5"
                }, " Close ")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.reissuemodal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("p", {
                  class: "close text-xl opacity-70 font-black text-green-500 cursor-pointer",
                  onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.closem && _ctx.closem(...args)))
                }, " ╳ ")
              ]),
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "ddown",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.uName) = $event)),
                    class: "w-full border h-10 mt-2 border-gray-300 rounded wful1",
                    style: {"outline":"none !important","border-width":"1px !important","border-right":"1px solid #00000029 !important"}
                  }, null, 512), [
                    [_vModelText, _ctx.uName]
                  ]),
                  _hoisted_66,
                  _hoisted_67
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "ddown",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.uEmail) = $event)),
                    class: "w-full border h-10 mt-2 border-gray-300 rounded wful1",
                    style: {"outline":"none !important","border-width":"1px !important","border-right":"1px solid #00000029 !important"}
                  }, null, 512), [
                    [_vModelText, _ctx.uEmail]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("button", {
                  onClick: _cache[13] || (_cache[13] = (...args) => (_ctx.submitm && _ctx.submitm(...args))),
                  class: _normalizeClass([{'opa-50': !_ctx.uEmail.trim().length || !_ctx.uName.trim().length  || !_ctx.invalidTicketEmail() }, "close px-8 py-2 text-sm text-white rounded-full bg-green-500 hover:bg-green-600 transition duration-300 ease-in-out mt-5"])
                }, " Submit ", 2)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showQRModal)
        ? (_openBlock(), _createBlock(_component_QRScanner, {
            key: 2,
            selectedEvent: _ctx.selectedEvent,
            onClose: _ctx.closeQRModal
          }, null, 8, ["selectedEvent", "onClose"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}